import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import ContactBlock from "./ContactBlock";
const ContactBlockPreview = () => {
    return (_jsx(ContactBlock, { title: "Un projet \u00E0 lancer, une \u00E9quipe \u00E0 mobiliser ?", subtitle: "Sous titre", link: {
            url: "/",
            title: "Lien vers la page",
        } }));
};
export default ContactBlockPreview;
